import { render } from "./BilesikFaiz.vue?vue&type=template&id=780e8bef"
import script from "./BilesikFaiz.vue?vue&type=script&lang=js"
export * from "./BilesikFaiz.vue?vue&type=script&lang=js"

import "./BilesikFaiz.vue?vue&type=style&index=0&id=780e8bef&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__